import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { postScore as _postScore, getEntries as _getEntries, getLeaderboardInstances as _getLeaderboardInstances, getLeaderboardInstanceById as _getLeaderboardInstanceById, getCycles as _getCycles } from "./methods/index.js";
import { defaultPostProcessor } from "./utils/postProcessor.js";
import { isFunction, isNonEmptyString } from "./utils/validators.js";
import { InvalidParameterError } from "./utils/errors/index.js";
import { createRequest } from "./methods/request.js";
/**
 * @category Outputs
 */

/**
 * This is used to create leaderboard client object
 *
 * ```typescript
 * import { createLeaderboardClient, defaultPostProcessor } from '@sgorg/leaderboard-client';
 *
 * async function getLdbClient<T>() {
 *   const fb = window.FBInstant;
 *   const playerInfo = await fb.player.getSignedPlayerInfoAsync();
 *   const signature = playerInfo.getSignature();
 *   return createLeaderboardClient<T>({gameSlug: 'gb-test-game', signature, postProcessor: defaultPostProcessor})
 * }
 * ```
 * @param initParams create leaderboard client parameters
 * @returns returns the leaderboard methods
 * @category Global
 */
export function createLeaderboardClient(initParams) {
  var gameSlug = initParams.gameSlug,
      signature = initParams.signature,
      postProcessor = initParams.postProcessor,
      endpointOverride = initParams.endpointOverride;

  if (!isNonEmptyString(gameSlug)) {
    throw new InvalidParameterError(1618237704, 'Parameter "gameSlug" must be a non-empty string.');
  }

  if (!isNonEmptyString(signature)) {
    throw new InvalidParameterError(1638552680, 'Parameter "signature" must be a non-empty string.');
  }

  if (!isFunction(postProcessor)) {
    throw new InvalidParameterError(1618243205, 'Parameter "postProcessor" must be a function.');
  }

  if (endpointOverride !== undefined) {
    if (!gameSlug.includes('test')) {
      throw new InvalidParameterError(1626945389, 'endpointOverride overriding only possible for gameSlug which contains "test"');
    }

    if (!isNonEmptyString(endpointOverride)) {
      throw new InvalidParameterError(1626945287, 'Parameter "endpointOverride" must be a non-empty string.');
    }
  }

  var request = createRequest(gameSlug, signature, endpointOverride);
  return {
    postScore: function () {
      var _postScore2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", _postScore(_objectSpread(_objectSpread({}, params), {}, {
                  request: request
                })));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function postScore(_x) {
        return _postScore2.apply(this, arguments);
      }

      return postScore;
    }(),
    getEntries: function () {
      var _getEntries2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", _getEntries(_objectSpread(_objectSpread({}, params), {}, {
                  request: request,
                  postProcessor: postProcessor
                })));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getEntries(_x2) {
        return _getEntries2.apply(this, arguments);
      }

      return getEntries;
    }(),
    getLeaderboardInstances: function () {
      var _getLeaderboardInstances2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", _getLeaderboardInstances(_objectSpread(_objectSpread({}, params), {}, {
                  request: request
                })));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function getLeaderboardInstances(_x3) {
        return _getLeaderboardInstances2.apply(this, arguments);
      }

      return getLeaderboardInstances;
    }(),
    getLeaderboardInstanceById: function () {
      var _getLeaderboardInstanceById2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", _getLeaderboardInstanceById(_objectSpread(_objectSpread({}, params), {}, {
                  request: request
                })));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function getLeaderboardInstanceById(_x4) {
        return _getLeaderboardInstanceById2.apply(this, arguments);
      }

      return getLeaderboardInstanceById;
    }(),
    getCycles: function () {
      var _getCycles2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(params) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", _getCycles(_objectSpread(_objectSpread({}, params), {}, {
                  request: request
                })));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function getCycles(_x5) {
        return _getCycles2.apply(this, arguments);
      }

      return getCycles;
    }()
  };
}
export { defaultPostProcessor };